export const sanityOptions = {
  projectId: '4wwd23e9',
  dataset: 'production',
  imageOptions: {
    "max-w": 640, "max-h": 480, fit: 'crop'
  }
}